import React, { useState, useEffect, useContext } from 'react'
import './styles.scss'
import { prepareNameData, preparePopulationData } from './functions'
import { NameInCultureChart } from 'components/charts/NameInCultureChart'
import Button from '@material-ui/core/Button'
import smoothscroll from 'smoothscroll-polyfill'

smoothscroll.polyfill()
const isMobile = window.innerWidth < 768

const nameDict = [
  ['Dua', 'Erstes Album der Sängerin Dua Lipa', 2014],
  ['Camila', 'Sängerin Camila Cabello startet ihre Solokarriere', 2015],
  // ['Inaya', 'Soprano chante «Inaya»', 2008],
  [
    'Ariana',
    'Ariana Grande wird durch ihre Rolle in der TV-Serie «Victorious» bekannt',
    2010
  ],
  ['Arya', 'Première saison de Game of Thrones', 2010],
  [
    'Bryan',
    'Bryan Adams landet mit «(Everything I Do) I Do It for You» einen internationalen Charthit',
    1991
  ],
  [
    'Malia',
    'Barack Obama, dessen Tochter Malia heisst, wird Präsident der USA',
    2009
  ],
  [
    'Diana',
    'Lady Diana lässt sich 1996 scheiden und stirbt 1997 bei einem Autounfall.',
    1996
  ],
  // ['Jordy', "Single de Jordy 'Dur dur d'être bébé'", 1992],
  ['Mégane', 'Der Renaut Mégane kommt auf die Strasse', 1995],
  ['Shania', 'Sängerin Shania Twain veröffnelticht «Come On Over»', 1999],
  ['Ron', 'Kinostart von «Harry Potter und der Stein der Weisen»', 2001],
  // ['Jon', 'Première saison de Game of Thrones', 2010], // delete
  ['Céleste', 'Erste Staffel der TV-Serie «Big Little Lies»', 2017],
  // ['Mélissa', 'Sortie de la chanson de Julien Clerc', 1984],
  [
    'Kevin',
    'Kinostart von «Kevin - Allein zu Haus» und «Der mit dem Wolf tanzt»',
    1990
  ] // delete
]

const curvecolors = [
  'var(--main-light)',
  'var(--secondary-light)',
  'var(--main-dark)',
  'var(--orange-main)',
  'var(--green-main)',
  'var(--purple-main)'
]
interface Props {
  data: [
    populationdataElementRaw[],
    womenMenDataElement[],
    womenMenDataElement[]
  ]
}
export const NameInCulture = ({ data }: Props) => {
  const [drawData, setDrawData] = useState<namedataElement[]>()
  const [selected, setSelected] = useState<namedataElement[]>([])

  useEffect(() => {
    if (!data || !data[0] || !data[1] || !data[2]) return
    const pop = data[0]
    const women = data[1]
    const men = data[2]

    const popdata: populationdataset = preparePopulationData(pop)
    const womensdata: namedateset = prepareNameData(women, popdata, 'w')
    const mensdata: namedateset = prepareNameData(men, popdata, 'm')
    const namedata = womensdata.concat(mensdata)
    const completeData = namedata.map(d => ({
      ...d,
      infos: nameDict.find(a => a[0] === d.name)
    }))
    setDrawData(completeData)
    setSelected(
      completeData
        .filter(f => ['Diana'].indexOf(f.name) !== -1)
        .sort((a, b) => a.name.localeCompare(b.name))
    )
  }, [])

  const handleSelect = name => {
    setSelected(drawData.filter(d => d.name === name))
  }

  return (
    <div className='NameChart'>
      {drawData && drawData.length > 0 && (
        <>
          <div className='nameholder'>
            <div className='selectedNamesB'>
              <NameSelectedList
                elements={drawData
                  .filter(f => nameDict.map(n => n[0]).includes(f.name))
                  .sort((a, b) => {
                    return a.name.localeCompare(b.name)
                  })}
                selected={selected[0].name}
                handleClick={handleSelect}
              />
            </div>
          </div>

          <NameInCultureChart
            data={drawData}
            selected={selected}
            colors={curvecolors}
          />
        </>
      )}
    </div>
  )
}

const NameSelectedList = ({
  elements,
  handleClick,
  selected
}: {
  elements: namedataElement[]
  handleClick: (e: any) => void
  selected: string
}) => {
  return (
    <>
      {elements.map((e, i) => {
        return (
          <NameButton
            key={i}
            name={e.name}
            color={e.name === selected ? curvecolors[1] : curvecolors[0]}
            handleClick={handleClick}
          />
        )
      })}
    </>
  )
}

const NameButton = ({
  name,
  color,
  handleClick
}: {
  name: string
  color: string
  handleClick: (e: any) => void
}) => {
  return (
    <Button
      variant='contained'
      color='primary'
      style={{
        color: color,
        backgroundColor: 'transparent',
        display: 'inline-block',
        textTransform: 'none',
        padding: '0.5em',
        textAlign: 'center',
        boxShadow: 'none',
        fontSize: '1em',
        letterSpacing: '1px',
        marginBottom: '.5em',
        borderRadius: '0.2em',
        marginRight: '.5em',
        whiteSpace: 'nowrap',
        lineHeight: 0
      }}
      onClick={() => {
        handleClick(name)
        if (isMobile) {
          const graphElement = document.getElementById('culture-chart')
          window.scrollTo({
            left: 0,
            top: graphElement?.getBoundingClientRect().top + window.scrollY,
            behavior: 'smooth'
          })
        }
      }}
      value={name}
    >
      <div
        className='name-button-portrait'
        style={{
          backgroundColor: color,
          backgroundImage:
            'url(' +
            require(`../${name.replace('é', 'e').toLocaleLowerCase()}.png`) +
            ')'
        }}
      />
      <div className='nameContainerB'>{name}</div>
    </Button>
  )
}
